import { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'sonner'
import { NavigationItems } from './header/NavigationItems'
import { AuthActions } from './header/AuthActions'
import { AnimatedLogo } from './header/AnimatedLogo'
import { useAuth } from '@/providers/AuthProvider'
import { queryClient } from '@/lib/queryClient'
import { isHeroPath } from '@/data/heroBackground'

const Header = () => {
  const [loading, setLoading] = useState(false)
  const { user, signOut } = useAuth()
  const location = useLocation()
  const navigate = useNavigate()
  const isPublicRoute = [
    '/',
    '/auth',
    '/login',
    '/signin',
    '/signup',
    '/register',
    '/forgot-password',
    '/reset-password',
    '/auth/callback',
    '/learn-more',
    '/faq',
    '/legal',
    '/goodbye',
    '/check-email',
    '/verify-email',
  ].includes(location.pathname) ||
    location.pathname.startsWith('/invitation/') ||
    location.pathname.startsWith('/invited-user-signup/') ||
    location.pathname.startsWith('/contact-approval/') ||
    location.pathname.startsWith('/d/')

  const isGoodbyePage = location.pathname === '/goodbye'
  const isAuthenticated = !isGoodbyePage && !!user

  const handleLogout = async () => {
    try {
      setLoading(true)
      queryClient.clear()
      await signOut()
      navigate('/signin', { replace: true })
    } catch (error) {
      console.error('Logout error:', error)
      toast.error('An unexpected error occurred during logout.')
    } finally {
      setLoading(false)
    }
  }

  const logoDestination = isAuthenticated ? '/dashboard' : '/'
  const isHero = isHeroPath(location.pathname)

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 ${isHero ? '' : 'border-b border-slate-200'}`}>
      {isHero ? null : (
        <div className={`absolute inset-0 ${isPublicRoute ? 'bg-white' : 'bg-slate-50'}`} />
      )}
      <div className="container mx-auto px-4 relative">
        <div className="h-16 flex items-center justify-between">
          <Link to={logoDestination} className={`flex items-center text-xl font-bold ${isHero ? 'text-white drop-shadow-sm' : 'text-black'}`}>
            <AnimatedLogo className="mr-2" onHero={isHero} />
            My Dead Man's Switch
          </Link>

          <div className="flex items-center gap-4">
            {isAuthenticated && !isGoodbyePage && <NavigationItems onHero={isHero} />}
            <AuthActions
              isAuthenticated={isAuthenticated && !isGoodbyePage}
              onLogout={handleLogout}
              loading={loading}
              onHero={isHero}
            />
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
